import styled from 'styled-components';

const FitContent = styled.span`
  min-width: fit-content;
`;

export default FitContent;
